
import { defineComponent, computed } from 'vue';
import { ActionTypes } from '@/store/actions';
import LoadingIcon from '@/components/UI/LoadingIcon.vue';
import { useStore } from '@/store';

export default defineComponent({
    name: 'SubmitButton',
    components: { LoadingIcon },
    setup () {
        const store = useStore();
        const submit = async () => await store.dispatch(ActionTypes.Subscribe);
        const isLoading = computed(() => store.state.isSubmitting);

        return { submit, isLoading };
    }
});
